import * as moment from 'moment-timezone';
import { Nullable } from 'src/core/common/domain/types/types';

/**
 * An IANA timezone name, validated against the database moment-timezone ships. Both the tenant zone
 * and each task's own zone arrive from the API as free text, and neither may be trusted: an
 * abbreviation ('CET'), a city ('Madrid') or a typo resolves to nothing, and moment would silently
 * fall back to the device's zone.
 */
export class Timezone {
  static readonly DEFAULT = 'Europe/Madrid';

  static isSupported(timezone: Nullable<string>): timezone is string {
    return !!timezone && moment.tz.zone(timezone) !== null;
  }

  /**
   * The first candidate the IANA database recognises, or DEFAULT when none of them is usable.
   * Callers pass the chain from most specific to least: the task's own zone, then the tenant's.
   *
   * Nullish coalescing cannot do this on its own. '' and 'CEST' are values, not gaps, so `??` keeps
   * them and the gap only surfaces further down, where the next fallback is no longer in reach.
   */
  static firstSupported(...candidates: Array<Nullable<string>>): string {
    const supported = candidates.find((candidate) => Timezone.isSupported(candidate));

    return supported ?? Timezone.DEFAULT;
  }
}
